import { put, call } from 'redux-saga/effects';
import { CampaignAction, UIAction } from '../actions';
import { CampaignService } from '../services';
import { generateReadableError } from 'hooks';

export function* getCampaigns(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.getCampaignsSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().fetchCampaigns, action.payload);
    yield put(CampaignAction.getCampaignsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getCampaignDetails(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.getCampaignsDataSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().fetchCampaignDetails, action.payload);
    yield put(CampaignAction.getCampaignsDataSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* changeStatus(action) {
  
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.changeStatusSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().changeStatus, action.payload);
    yield put(CampaignAction.changeStatusSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getCharges(action) {
  
  
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.getCampaignChargesSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().fetchCharges, action.payload);
    yield put(CampaignAction.getCampaignChargesSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* saveCharges(action) {
  
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.saveCampaignChargesSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().saveCharges, action.payload);
    yield put(CampaignAction.saveCampaignChargesSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}



export function* getInterest(action) {
  
  
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.getInterestSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().fetchInterest, action.payload);
    yield put(CampaignAction.getInterestSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    console.log('Error:', e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* saveInterest(action) {
  
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.saveInterestSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().saveInterest, action.payload);
    yield put(CampaignAction.saveInterestSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* deleteInterest(action) {
  
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.deleteInterestSuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().deleteInterest, action.payload);
    yield put(CampaignAction.deleteInterestSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getTransactionHistory(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(CampaignAction.getTransactionHistorySuccess(null));
  try {
    const { data } = yield call(CampaignService.getInstance().fetchTransactionHistory, action.payload);
    yield put(CampaignAction.getTransactionHistorySuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}





